import React, { useEffect, useState } from "react";
import { globalVariables } from "../../../../global/GlobalVariables";
import { Helmet } from "react-helmet-async";
import { getData } from "../../../../components/utilities/UtilityFunctions";

export default function EventHelmet(props) {
  const globalVars = globalVariables();

  const { event } = props;
  const [title, setTitle] = useState(`Event | ${globalVars.site.title}`);
  const [description, setDescription] = useState(globalVars.site.description);
  const [image, setImage] = useState(globalVars.site.logo);
  const url = window.location.href;

  useEffect(() => {
    // Set title
    if (event?.name && event?.name !== "") {
      setTitle(`${event.name} | ${globalVars.site.title}`);
    }

    // Set description
    if (event?.description && event?.description !== "") {
      const trimmedDesc = trimDescription(event?.description, 123);

      setDescription(trimmedDesc);
    }

    // Set Image
    if (event?.photoUrl) {
      setImage(event.photoUrl);
    }
    if (!event?.photoUrl && event?.photoFileId) {
      const go = async () => {
        try {
          const apiImage = fetchFile(event?.photoFileId);

          setImage(apiImage.url);
        } catch {}
      };

      go();
    }

    // eslint-disable-next-line
  }, [event]);

  const trimDescription = (desc, length) => {
    // Remove newline characters (\n) from the string
    desc = desc.replace(/\n/g, " ");

    // Replace consecutive spaces with a single space
    desc = desc.replace(/\s\s+/g, " ");

    if (desc.length <= length) {
      return desc;
    }

    // Trim the string to the maximum length
    let trimmedString = desc.substr(0, length);

    // Re-trim the string to avoid breaking words
    trimmedString = trimmedString.substr(
      0,
      Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
    );

    // Add "..." to the end of the trimmed string
    trimmedString += "...";

    return trimmedString;
  };

  const fetchFile = async (fileId) => {
    if (!fileId) return;

    var returnObj;
    try {
      returnObj = await getData(`/files/${fileId}`, {
        queryStringParameters: {
          // size: fileSize,
        },
      });
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta property="title" content={title} />
      <meta property="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content={`Event image for: ${title}`} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      {/* <meta property="twitter:image" content={image} /> */}
      {/* <meta property="twitter:image:src" content={image} /> */}
    </Helmet>
  );
}
